
import isArray from "lodash/isArray";
import isPlainObject from "lodash/isPlainObject";
import mapKeys from "lodash/mapKeys";
import mapValues from "lodash/mapValues";
import camelCase from "lodash/camelCase";
import snakeCase from "lodash/snakeCase";

export type KeyMapper = (s: string) => string;

const recursivelyMapKeys = (keyMapper: KeyMapper) => {
  const objectMapper = (data: object): any =>
    mapValues(
      mapKeys(data, (_value, key) => keyMapper(key)),
      (value, _key) => {
        if (isPlainObject(value)) return objectMapper(value);
        if (isArray(value))
          return (value as Array<any>).map((v) =>
            isPlainObject(v) ? objectMapper(v) : v
          );
        return value;
      }
    );
  return objectMapper;
};

export const camelify = recursivelyMapKeys(camelCase);
export const snakeify = recursivelyMapKeys(snakeCase);

